import React, { useState } from 'react'
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { DropdownTopbarItemToggler } from '../../../../_metronic/_partials/dropdowns';
import clsx from "clsx";
import './styles.css'
import api from '../../../services/api'
import { getStructureTreeBancoDeDados } from "../../../modules/Auth/_redux/authCrud";
import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = EncryptStorage('secret_key', {
    prefix: '@prefix'
  });

export class FactorySelectionDropdown extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
        entities: [],
        myFactoryName: ''
      }
      if (encryptStorage.getItem('Factory'))
          this.state.myFactoryName = encryptStorage.getItem('Factory').name
    this.fetchData = this.fetchData.bind(this)
    this.setFactorySelection = this.setFactorySelection.bind(this)
  }


    fetchData() {
        
    api.get('/factory/odata?$select=id,name&$orderby=name asc').
      then(( response ) => {
        if ( response.status === 200 && Array.isArray(response.data.value) ) {
          this.setState({
            entities: response.data.value
          })
          if (!encryptStorage.getItem('Factory')) {
              this.setFactorySelection(response.data.value[0])
          }
        }
      }).catch((err) => {
        console.log(err)
        this.setState({
          entities: []
        })
      })
  }

  componentDidMount() {
      this.fetchData()
  }

  setFactorySelection ( factory ) {
    encryptStorage.setItem('Factory', JSON.stringify(factory))
      this.state.myFactoryName = factory.name;
    this.fetchStructures(factory.id)
  }

  async fetchStructures (id) {
    //console.log(id);
      const structureTree = await getStructureTreeBancoDeDados(id);
      localStorage.setItem('StructureTree', JSON.stringify(structureTree));

    api.get('/structure/odata?$filter=factoryId+eq+'+id).
      then(( response ) => {
          //console.log(response.data.value)
          const structures = response.data.value.map(o => ({key:o.id, value:o.name}));
          //console.log(structures);
          localStorage.setItem('structures', JSON.stringify(structures));

          // @todo Mudar para uma forma melhor
          window.location.reload();
        })
  }

  render() {
    return (
      <>
        <Dropdown drop="down" alignRight  onClick={(e) => e.stopPropagation()}>
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
          >
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="language-panel-tooltip">Selecione a fábrica</Tooltip>
              }
              >
                <div className={"btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"}>
                  <span className="text-dark-50 font-weight-bolder font-size-base mr-3">
                    {this.state.myFactoryName}
                  </span>
                </div>
              </OverlayTrigger>
            </Dropdown.Toggle>

          <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
            <ul className="navi navi-hover py-4">
            <div className="listFab">
              {this.state.entities.map(( factory ) => (
                <li
                  key={factory.id}
                  className={clsx("navi-item", {
                      active: factory.id === encryptStorage.getItem('Factory').id,
                  })}
                >
                  <a
                    href="#"
                    onClick={() => { this.setFactorySelection(factory) }}
                    className="navi-link"
                  >
                    <span className="navi-text">{factory.name}</span>
                  </a>
                </li>
              ))}
              </div>
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </>
    )
  }
}